import LayoutProducts from "@/layout/products";

import ProductsSearch from '@/views/productsSearch'
import Product from "@/views/product";
import Recipe from "@/views/recipe";
import CommerceProducts from "@/components/commerceProducts/commerceProducts";
import Principal from "@/views/Principal";
import ChallengeInfo from "@/views/challenge-info/challenge-info.vue";
// import { mainView, hasCity, hideShowIntercom } from "./guard.ts";
import ProductDetail from '@/components/productDetail/productDetail'
import CommerceCategoryDetail from '@/components/commerceCategoryDetail/commerceCategoryDetail'
import FeaturedProducts from '@/components/featuredProducts/featuredProducts'

export default [
  {
    path: "/:city_id",
    component: LayoutProducts,
    redirect: { name: 'featuredProducts'},
    name: "city",
    // beforeEnter: hasCity, hideShowIntercom,
    children: [
      {
        path: "/:city_id/pasillos",
        name: "superCategories",
        component: CommerceProducts
      },
      {
        path: "/:city_id/parati",
        name: 'featuredProducts',
        component: FeaturedProducts
      },
      {
        path: '/busqueda',
        name: 'search',
        component: ProductsSearch
      },
      {
        path: '/:city_id/productos/:product_id',
        name: 'productDetail',
        component: ProductDetail
      },
      {
        path: '/:city_id/productos/categorias/:category_id',
        name: 'commerceCategory',
        component: CommerceCategoryDetail
      }
    ]
  },
  {
    path: "/product/:id",
    component: Product,
    name: "product"
  },
  {
    path: "/recipe/:id",
    component: Recipe,
    name: "recipe"
  },
  {
    path: "/retos-info",
    component: ChallengeInfo,
    name: "challengeInfo"
  }
];
